import { addNotification, getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reducePolicy } from '../../actions/policy/reducePolicy';
import { getPolicySummarySaga } from './getPolicySummarySaga';

export function* setEndorsementToLostSaga(action) {
    try {
        yield put(reduceLoading({ code: 'setEndorsementToLost', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyEndorsement/settolost', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                policyTransactionGuid: action.payload.policyTransactionGuid,
                lostReasonCode: action.payload.lostReasonCode,
                lostReasonDescription: action.payload.lostReasonDescription,
            }),
        });

        const result = yield call([response, 'json']);

        if (result.operation?.status) {
            // Refresh in place so the transaction status reflects "lost".
            if (result.policyTransaction) {
                yield put(reducePolicy(result.policyTransaction));
            }
            yield getPolicySummarySaga();
        } else {
            yield put(
                addNotification({
                    code: 'setEndorsementToLost',
                    type: 'error',
                    errors: result.operation?.errors,
                    message: action.payload.errorMessage,
                }),
            );
        }

        yield put(reduceLoading({ code: 'setEndorsementToLost', value: false }));
    } catch (error) {
        console.log('Error while setting Endorsement to Lost API - ', error);
        yield put(reduceLoading({ code: 'setEndorsementToLost', value: false }));
        yield put(
            addNotification({
                code: 'setEndorsementToLost',
                type: 'error',
                message: action.payload.errorMessage,
            }),
        );
    }
}
